import React from "react";
import StatusApplication from "./StatusApplication";
import { checkPermission, permissionsConfig } from '../AdminPermission/PermissionChecker';

const WithdrawalApplications = () => {

  const editApplicationPermission = checkPermission(
    permissionsConfig.editWithdrawalApplications.role,
    permissionsConfig.editWithdrawalApplications.action,
    permissionsConfig.editWithdrawalApplications.type
  );
    
  const deleteApplicationPermission = checkPermission(
    permissionsConfig.deleteWithdrawalApplications.role,
    permissionsConfig.deleteWithdrawalApplications.action,
    permissionsConfig.deleteWithdrawalApplications.type
  );

  return (
    <StatusApplication appStatus="10" title="Withdrawal" subTitle="Withdrawal" application_type="" pageFrom="withdrawal-applications" editApplicationPermission={editApplicationPermission} deleteApplicationPermission={deleteApplicationPermission}></StatusApplication>
  )
}

export default WithdrawalApplications;
